import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-961aa7e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/logo.png" })
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" SEJA BEM-VINDO AO ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" JAÚ SERVE ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Muito mais que um supermercado, um clube de vantagens! ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon-layout",
    src: "/assets/img/carrinho_novidade.svg"
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("NOVIDADE ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Agora você faz suas compras direto pelo App! ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon-layout",
    src: "/assets/img/porquinho.svg"
  })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" ECONOMIA EM PRIMEIRO LUGAR ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Além de descontos exclusivos, você participa de promoções e recebe ofertas em primeira mão! ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Avançar ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Concluir ")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Pular ")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_swiper, {
            pagination: true,
            modules: _ctx.modules,
            onSwiper: _ctx.onSwiper,
            onReachEnd: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isLast=true))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_swiper_slide, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center font-montserrat-bold font-20",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2,
                          _hoisted_3,
                          _hoisted_4,
                          _hoisted_5
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center font-raleway font-12",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6,
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_swiper_slide, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center font-montserrat-bold font-20",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9,
                          _hoisted_10
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center font-montserrat font-12",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11,
                          _hoisted_12
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_swiper_slide, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center font-montserrat-bold font-20",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14,
                          _hoisted_15
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center font-montserrat font-12",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_16,
                          _hoisted_17
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modules", "onSwiper"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, { class: "ion-no-border" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                class: "ion-text-center font-raleway",
                size: "2"
              }),
              (!_ctx.isLast)
                ? (_openBlock(), _createBlock(_component_ion_col, {
                    key: 0,
                    class: "ion-text-center",
                    size: "8"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toEnd())),
                        color: "jauservelayoutalter",
                        size: "large",
                        shape: "round",
                        expand: "block"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_18
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isLast)
                ? (_openBlock(), _createBlock(_component_ion_col, {
                    key: 1,
                    class: "ion-text-center",
                    size: "8"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goLogin())),
                        color: "jauservelayoutalter",
                        size: "large",
                        shape: "round",
                        expand: "block"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_19
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_col, {
                class: "padding",
                size: "12"
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                class: "ion-text-center font-raleway font-30",
                size: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goLogin())),
                    size: "large",
                    color: "jauservelayoutalter",
                    expand: "block",
                    fill: "clear"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                class: "padding",
                size: "12"
              }, {
                default: _withCtx(() => [
                  _hoisted_22,
                  _hoisted_23
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}